/* @flow */
const prefix = str => `station/data-feeds/${str}`;

export const FETCH_ALL = prefix('FETCH_ALL');
export const FETCH_ALL_SUCCESS = prefix('FETCH_ALL_SUCCESS');
export const FETCH_ALL_FAILURE = prefix('FETCH_ALL_FAILURE');

export const SUBSCRIBE = prefix('SUBSCRIBE');
export const SUBSCRIBE_SUCCESS = prefix('SUBSCRIBE_SUCCESS');
export const SUBSCRIBE_FAILURE = prefix('SUBSCRIBE_FAILURE');



// WEBPACK FOOTER //
// ./src/app/modules/data-feeds/action-types.js